
export const SPIELER_ACTION_SETTINGS = {
    editNew: {
        icon: 'mdi-pencil',
        toolTip: 'Mitgliedsdaten ändern',
        toolTipPass: 'Mitgliedsdaten geändert',
        actionType: 'editNew',
    },
    edit: {
        icon: 'mdi-account-edit',
        toolTip: 'Mitgliedsdaten ändern',
        toolTipPass: 'Mitgliedsdaten oder Foto geändert',
        actionType: 'edit',
    },
    delete: {
        icon: 'mdi-trash-can-outline',
        toolTip: 'Neues Mitglied wieder löschen',
        actionType: 'delete',
    },
    loeschen: {
        icon: 'mdi-trash-can-outline',
        toolTip: 'Mitglied unwiderruflich löschen',
        actionType: 'loeschen',
    },
    drucken: {
        icon: 'mdi-printer',
        toolTip: 'Pass - Druckstatus ändern',
        actionType: 'drucken',
    },
    foto: {
        icon: 'mdi-camera-account',
        toolTip: 'Passfoto hochladen',
        toolTipPass: 'Passfoto hochgeladen',
        actionType: 'foto',
    },
    ummeldung: {
        icon: 'mdi-account-convert',//'mdi-account-arrow-right',
        toolTip: 'Ummeldung (Vereinswechsel) und Leihe',
        toolTipPass: 'Ummeldung (Vereinswechsel) oder Leihe',
        actionType: 'ummeldung',
    },
    leihe: {
        icon: 'mdi-account-convert',//'mdi-account-arrow-right',
        toolTip: 'Ummeldung (Vereinswechsel) und Leihe',
        toolTipPass: 'Ummeldung (Vereinswechsel) oder Leihe',
        actionType: 'leihe',
    },
    abmeldung: {
        icon: 'mdi-account-cancel',
        toolTip: 'Abmeldung',
        actionType: 'abmeldung',
    },
    verlaengerung: {
        icon: 'mdi-alert',
        toolTip: 'Aktion erforderlich, Pass muss verlängert werden',
        toolTipPass: 'Pass wurde verlängert',
        actionType: 'verlaengerung',
    },
    bestaetigungen: {
        icon: 'mdi-file-document-multiple-outline',
        toolTip: 'Datum von Attest, ADE, DSV aktualisieren',
        actionType: 'bestaetigungen',
    },
    wiederanmeldung: {
        icon: 'mdi-account-reactivate',
        toolTip: 'Mitglied wieder anmelden',
        toolTipPass: 'Spieler wurde wiederangemeldet',
        actionType: 'wiederanmeldung',
    },
    passDuplikat: {
        icon: 'mdi-card-account-details',
        toolTip: 'Pass-Duplikat',
        toolTipPass: 'Pass-Duplikat',
        actionType: 'passDuplikat',
    },
    resetNew: {
        icon: 'mdi-undo',
        toolTip: 'zurücksetzen auf beantragt',
        actionType: 'resetToBeantragt',
    },
}